import PhoneNumberForm from './components/PhoneNumberForm';
import VerifyCodeForm from './components/VerifyCodeForm';
import CardScreen from '../../components/CardScreen/CardScreen';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../features/auth';

const LoginScreen = () => {

    const { t } = useTranslation()
    const { status } = useSession();

    return (
        <CardScreen title={status === "MFA_REQUIRED" ? t('verification_code') : t("signin_title")}>
            {status === "MFA_REQUIRED" ? <VerifyCodeForm /> : <PhoneNumberForm />}
        </CardScreen>
    )
}

export default LoginScreen